import { fetchMailAttachmentBlobCached } from "@/lib/cache/fetchMailAttachmentBlobCached";
import { isPreviewableAttachment } from "@/lib/mail/attachmentPreview";
import type { MailMessageDetail } from "@/lib/types/mail";

const MAX_PREFETCH_BYTES = 10 * 1024 * 1024;
const inflight = new Set<string>();

function prefetchKey(accountId: number, folder: string, uid: number, part: string): string {
  return `${accountId}\0${folder}\0${uid}\0${part}`;
}

/** Précharge les PJ previewables (PDF, images…) après warm corps — sans bloquer l’UI. */
export function prefetchPreviewAttachments(
  accountId: number,
  folder: string,
  message: MailMessageDetail
): void {
  const uid = message.uid;
  if (accountId < 1 || uid <= 0) return;

  const attachments = message.attachments ?? [];
  for (const file of attachments) {
    if (!file.part || !isPreviewableAttachment(file)) continue;
    if ((file.size ?? 0) > MAX_PREFETCH_BYTES) continue;

    const key = prefetchKey(accountId, folder, uid, file.part);
    if (inflight.has(key)) continue;
    inflight.add(key);

    void fetchMailAttachmentBlobCached({
      accountId,
      folder,
      uid,
      part: file.part,
      filename: file.filename,
    })
      .catch(() => {
        /* best effort */
      })
      .finally(() => {
        inflight.delete(key);
      });
  }
}
